enum PageTypes {
  Question = 'question',
  AdditionalQuestions = 'additionalQuestions',
  Timer = 'timer',
  Banner = 'banner',
  Waiting = 'waiting'
};

export default PageTypes;